'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint jsx-a11y/media-has-caption: 0 */

var HtmlVideo = function HtmlVideo(props) {
  return _react2.default.createElement('video', {
    autoPlay: props.autoPlay,
    className: 'html-video ' + props.className,
    loop: props.loop,
    muted: props.muted,
    poster: props.poster
  }, _react2.default.createElement('source', {
    src: props.src
  }));
};
HtmlVideo.defaultProps = {
  autoPlay: true,
  className: '',
  loop: true,
  muted: true,
  poster: ''
};
HtmlVideo.propTypes = {
  autoPlay: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  loop: _propTypes2.default.bool,
  muted: _propTypes2.default.bool,
  poster: _propTypes2.default.string,
  src: _propTypes2.default.string.isRequired
};
exports.default = HtmlVideo;